module.exports = __webpack_public_path__ + "static/media/2.9e02daf1.jpg";